import store from '@/store'
import router from '@/router'
import i18n from '../../lang'
import { getTimeCodes, getTimeCode, createTimeCode, updateTimeCode, checkTimeCodePermissions, deleteTimeCode } from '@/backend/timeCodes'

const state = {
  timeCode: {},
  timeCodeList: []
}

export const mutations = {
  SET_TIME_CODE_LIST: (state, { timeCodeList }) => {
    state.timeCodeList = timeCodeList
  },
  SET_TIME_CODE: (state, { timeCode }) => {
    state.timeCode = timeCode;
  },
  SET_START_TIME: (state, startTime) => {
    state.timeCode.start_time = startTime
  },
  SET_END_TIME: (state, endTime) => {
    state.timeCode.end_time = endTime
  },
};

export const actions = {
  loadList({ commit, dispatch }, entityId) {
    return getTimeCodes(entityId)
    .then((response) => {
      let timeCodeList = response.data
      commit('SET_TIME_CODE_LIST', { timeCodeList: timeCodeList })
      timeCodeList.length === 0 ? store.dispatch('noData/enable') : store.dispatch('noData/disable')
    })
    .catch((error) => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  },

  get({ commit, dispatch }, timeCodeId) {
    return getTimeCode(timeCodeId)
    .then((response) => {
      commit('SET_TIME_CODE', { timeCode: response.data })
    })
    .catch((error) => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  },

  create({ commit, dispatch }, timeCodeParams) {
    return createTimeCode(timeCodeParams)
    .then((response) => {
      let timeCode = response.data
      return Promise.resolve(timeCode)
    })
    .catch(error => {
      let errorMessage = error.response.data.error
      return Promise.reject(errorMessage)
    })
  },

  update({ commit, dispatch }, timeCodeParams) {
    return updateTimeCode(timeCodeParams)
    .then((response) => {
      let timeCode = response.data
      return Promise.resolve(timeCode)
    })
    .catch(error => {
      let errorMessage = error.response.data.error
      return Promise.reject(errorMessage)
    })
  },

  checkPermissions({ commit }, timeCodeId) {
    return checkTimeCodePermissions(timeCodeId)
    .then(response => {
      return response.data
    })
    .catch(error => {
      dispatch('message/enable', { type: 'danger', content: error.response.data.error }, { root: true });
      return false;
    })
  },

  delete({ commit, dispatch }, timeCode) {
    return deleteTimeCode(timeCode.id)
    .then( (response) => {
      dispatch('loadList', timeCode.entity_id)
      let message = { type: 'success', content: i18n.t('messages.time_code_delete_success') }
      store.dispatch('message/enable', message)
    })
    .catch(error => {
      var message = { type: 'danger', content: error.response.data.error }
      store.dispatch('message/enable', message)
    })
  },
  updateStartTime({commit, dispatch}, startTime) {
    commit('SET_START_TIME', startTime)
  },
  updateEndTime({commit, dispatch}, endTime) {
    commit('SET_END_TIME', endTime)
  },
  initTimeCode({commit, dispatch}, params) {
    commit('SET_TIME_CODE', params)
  }
};

export const getters = {
  timeCodeList: state => state.timeCodeList,
  timeCode: state => state.timeCode
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/timeCodes.js